<template>
  <div>
    <div class="page-title">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">成績管理</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container pb-5 bg-white mt-5">
      <template v-if="isEmpty">
        <empty-page class="pt-5" title="尚無資料" description="目前沒有任何已建立的資訊。" />

        <div class="row mt-3">
          <div class="col-1">
            <button class="btn btn-block" @click.stop.prevent="$router.go(-1)" v-if="type !== 'index'">
              <img src="~../../assets/image/icon/step_back.png" />
            </button>
          </div>
        </div>
      </template>

      <div class="row" v-else>
        <div class="col-sm-12 p-3 border border-right-0 border-left-0 border-top-0 mb-5" style="font-size: 26px;">
          {{ name }}
        </div>

        <div class="col-sm-8 offset-sm-2">
          <div>
            <button class="btn btn-sm btn-primary" @click="getAttachment(courseId, groupId)" v-if="type === 'course-students'">下載Excel報表</button>
          </div>

          <div class="border rounded pt-3 pb-3 pl-5 pr-5" v-if="type === 'exam-students'">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>學號</th>
                  <th>姓名</th>
                  <th>總分</th>
                  <th>狀態</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="(item, index) in list" :key="'type-' + index">
                  <td>{{ item.studentNo }}</td>
                  <td>{{ item.realName }}</td>
                  <td>{{ item.totalScore }}</td>
                  <td>{{ item.isExamed ? '已考' : '未考' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <ul class="list-group" v-else>
            <li class="list-group-item d-flex justify-content-between p-0 rounded mb-3"
              :class="{ 'border-right-0 border-left-0 border-top-0': type === 'student-lessons' || type === 'course-students' }"
              v-for="(item, index) in list" :key="'type-' + index"
              v-on:mouseover="pointer = item.id"
              v-on:mouseout="pointer = null">
              <template v-if="type === 'index'">
                <div class="w-100 text-left p-3" style="line-height: 150%;">
                  <span v-html="item.name" /><br>指導老師：{{ item.teacherName }}
                </div>

                <div class="d-flex align-items-center justify-content-end" style="width: 430px;">
                  <transition
                    enter-active-class="animated fadeIn"
                    leave-active-class="d-none">
                    <span class="pr-3 text-right" v-if="pointer !== item.id">共 {{ item.studentCount }} 位學生</span>
                  </transition>

                  <transition
                    enter-active-class="animated fadeIn"
                    leave-active-class="d-none">
                    <div class="w-100 text-right" v-if="pointer === item.id">
                      <icon-button name="book" alt="作業成績" @click.native="$router.push({ name: 'record-mgr.courses', params: { groupId: item.id } })" />
                      <icon-button name="test" alt="考試成績" @click.native="$router.push({ name: 'record-mgr.exams', params: { groupId: item.id } })" />
                    </div>
                  </transition>
                </div>
              </template>

              <template v-if="type === 'course'">
                <div class="w-100 text-left p-3" style="line-height: 300%;">
                  <span v-html="item.name" /> （{{ item.createTime }}）
                </div>

                <div class="d-flex align-items-center rounded list-group-item-playbtn">
                  <span class="w-100 text-center"
                    @click="name = item.name; $router.push({ name: 'record-mgr.course-students', params: { groupId: groupId, courseId: item.id } })">
                    <img src="~../../assets/image/icon/btn_text_play.png" height="12">
                  </span>
                </div>
              </template>

              <template v-if="type === 'course-students'">
                <div class="w-100 text-left p-3" style="line-height: 150%;">
                  {{ item.studentNo }} {{ item.realName }} <br>學習次數：{{ item.learnCount }} 學習總時間：{{ item.spendTime }}
                </div>

                <div class="d-flex align-items-center mr-2">
                  <img src="~../../assets/image/icon/check_on.png" v-if="item.isDone">
                  <img src="~../../assets/image/icon/check_off.png" v-else>
                </div>

                <div class="d-flex align-items-center mr-3">
                  <icon-button name="more_dots" alt="更多" @click.native="$router.push({ name: 'record-mgr.student-lessons', params: { courseId: courseId, studentId: item.id } })" />
                </div>
              </template>

              <template v-if="type === 'student-lessons'">
                <div class="w-100 text-left p-3" style="line-height: 300%;">
                  {{ (index + 1) }}. {{ item.localName }} <span v-html="item.name" />
                </div>

                <div class="d-flex align-items-center mr-3">
                  <img src="~../../assets/image/icon/check_on.png" v-if="item.isDone">
                  <img src="~../../assets/image/icon/check_off.png" v-else>
                </div>
              </template>

              <template v-if="type === 'exam'">
                <div class="w-100 text-left p-3" style="line-height: 300%;">
                  <span v-html="item.name" /> （{{ item.createTime }}）
                </div>

                <div class="d-flex align-items-center rounded list-group-item-playbtn">
                  <span class="w-100 text-center"
                    @click="name = item.name; $router.push({ name: 'record-mgr.exam-students', params: { groupId: groupId, courseId: item.id } })">
                    <img src="~../../assets/image/icon/btn_text_play.png" height="12">
                  </span>
                </div>
              </template>
            </li>
          </ul>
        </div>

        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-1">
              <button class="btn btn-block" @click.stop.prevent="$router.go(-1)" v-if="type !== 'index'">
                <img src="~../../assets/image/icon/step_back.png" />
              </button>
            </div>

            <div class="col-4 offset-3" v-if="pageCount > 1">
              <pagination :current="pageIndex" :total="pageCount" v-on:page="updatePage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../store/api'
import Pagination from '../../components/Pagination'
import EmptyPage from './EmptyPage'
import 'animate.css'
import IconButton from './IconButton'
import langMixin from '../../components/langMixin'

export default {

  name: 'TeachingGroupRecord',

  components: {
    Pagination,
    EmptyPage,
    IconButton
  },

  mixins: [langMixin],

  data () {
    return {
      list: [],
      pageIndex: 1,
      pageCount: 0,
      pointer: null,
      type: 'index',
      groupId: null,
      courseId: null,
      studentId: null,
      name: ''
    }
  },

  computed: {
    isEmpty () {
      return this.list.length === 0
    }
  },

  mounted () {
    this.getType()

    this.$watch('$route.params.groupId', (val, oldVal) => {
      this.getType()
    })

    this.$watch('$route.params.courseId', (val, oldVal) => {
      this.getType()
    })

    this.$watch('$route.params.studentId', (val, oldVal) => {
      this.getType()
    })
  },

  methods: {
    getType () {
      this.groupId = this.$route.params.groupId
      this.courseId = this.$route.params.courseId
      this.studentId = this.$route.params.studentId

      if (this.groupId) {
        if (this.$route.name === 'record-mgr.courses') {
          this.type = 'course'
          this.name = '作業成績列表清單'
        } else if (this.$route.name === 'record-mgr.exams') {
          this.type = 'exam'
          this.name = '作業成績列表清單'
        } else if (this.$route.name === 'record-mgr.course-students' && this.courseId) {
          this.type = 'course-students'
        } else if (this.$route.name === 'record-mgr.exam-students' && this.courseId) {
          this.type = 'exam-students'
        }
      } else {
        if (this.$route.name === 'record-mgr.student-lessons' && this.courseId && this.studentId) {
          this.type = 'student-lessons'
        } else {
          this.type = 'index'
          this.name = '班級列表'
        }
      }
      this.list = []
      this.pageIndex = 1
      this.pageCount = 0
      this.updatePage()
    },

    updatePage (page) {
      page = page || 1

      if (this.type === 'course') {
        this.getCourses(this.groupId, page)
      } else if (this.type === 'exam') {
        this.getExams(this.groupId, page)
      } else if (this.type === 'course-students') {
        this.getCourseStudent(this.groupId, this.courseId, page)
      } else if (this.type === 'exam-students') {
        this.getExamStudent(this.groupId, this.courseId, page)
      } else if (this.type === 'student-lessons') {
        this.getStudentLessons(this.courseId, this.studentId, page)
      } else {
        this.getList(page)
      }
    },

    async getList (page) {
      const { data } = await api.get('/GroupMgr/TeachingGroups', { params: { pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'index'
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getCourses (groupId, page) {
      const { data } = await api.get('/CourseMgr/TeachingCourses', { params: { groupId: groupId, pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'course'
        this.list = this.jsonDataParsingRuby(data.data)
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getCourseStudent (groupId, courseId, page) {
      const { data } = await api.get('/CourseMgr/TeachingCourse/' + courseId + '/Groups/' + groupId + '/Students/Record', { params: { pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'course-students'
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getStudentLessons (courseId, studentId, page) {
      const { data } = await api.get('/CourseMgr/TeachingCourse/' + courseId + '/Students/' + studentId + '/Record', { params: { pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'student-lessons'
        this.list = this.jsonDataParsingRuby(data.data)
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getExams (groupId, page) {
      const { data } = await api.get('/ExamMgr/TeachingExams', { params: { groupId: groupId, pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'exam'
        this.list = this.jsonDataParsingRuby(data.data)
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getExamStudent (groupId, courseId, page) {
      const { data } = await api.get('/ExamMgr/TeachingExams/' + courseId + '/Groups/' + groupId + '/Students/Record', { params: { pageIndex: page } })

      if (data.status === 'OK') {
        this.type = 'exam-students'
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    getAttachment (courseId, groupId) {
      api.get('/CourseMgr/TeachingCourse/' + courseId + '/Groups/' + groupId + '/Students/ExcelReport')
        .then((res) => {
          let link = document.createElement('a')
          link.href = res.data.data
          link.click()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-group-item {
    &:hover {
      box-shadow: 0 0 8px #a1a1a1;
      transition: box-shadow 0.2s ease-in-out;
    }
  }
</style>


// WEBPACK FOOTER //
// TeachingGroupRecord.vue?fb54c216